<template>
  <div class="pagination">
    <!-- <button type="button" class="btn-prev"><span>首页</span></button> -->
    <!-- <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="1"
      prev-text="上一页"
      next-text="下一页"
      layout="prev, pager, next"
      :total="total"
    >
    </el-pagination> -->
    <nav aria-label="Page navigation">
      <ul class="pagination my_pagination">
        <li>
          <a
            class="btn-prev"
            aria-label="Previous"
            @click="handleCurrentChange(1)"
          >
            <span aria-hidden="true">首页</span>
          </a>
        </li>
        <li>
          <a
            class="btn-prev"
            aria-label="Previous"
            @click="handleCurrentChange(currentPage - 1)"
          >
            <span aria-hidden="true">上一页</span>
          </a>
        </li>
        <li v-for="(item, index) in total" :key="index">
          <a class="btn-prev" @click="handleCurrentChange(item)">{{ item }}</a>
        </li>
        <li>
          <a
            class="btn-prev"
            aria-label="Next"
            @click="handleCurrentChange(currentPage + 1)"
          >
            <span aria-hidden="true">下一页</span>
          </a>
        </li>
        <li>
          <a
            class="btn-prev"
            aria-label="Next"
            @click="handleCurrentChange(total)"
          >
            <span aria-hidden="true">末页</span>
          </a>
        </li>
      </ul>
    </nav>
    <!-- <button type="button" class="btn-prev"><span>末页</span></button> -->
    <div class="btn-prev total">
      <span>共{{ total }}页 {{ totalCount }}条</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: Number,
    total: Number,
    totalCount: Number,
  },
  data() {
    return {};
  },

  mounted() {},
  destroyed() {},
  methods: {
    handleCurrentChange(val) {
      if (val > this.total || val < 0) {
      } else {
        this.$emit("handleCurrentChange", val);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  margin: 50px 0;
  padding-bottom: 50px;

  .btn-prev {
    background-color: #fff;
    height: 28px;
    white-space: nowrap;
    border: 1px solid #82848a;
    padding: 0 10px;
    margin: 0 5px;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    cursor: pointer;
    line-height: 2;
  }
}

.my_pagination {
  margin: 0;
}

.total {
  cursor: auto;
}
</style>
<style lang="stylus" scoped>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #595757 !important;
  color: #fff;
}
@media screen and (max-width: 800px) {
  .pagination {
    font-size:1rem;
  }
}
</style>